module.exports = __webpack_public_path__ + "static/404-8d1b2ae8fd275fca69a68a76464a3e02.svg";